import {createDecorator} from "vue-class-component";

/**
 * decorator of a watch function
 * @param  key the key which is used for the shortcut. E.g 's' for a shortcut that uses Ctrl + s
 * @return MethodDecorator
 */
export function CtrlKeyboardShortcut(key: string) {
    return createDecorator((options: any, propertyKey: string) =>  {
        if (!options["__shortcuts__"])
            options["__shortcuts__"] = [];

        options["__shortcuts__"].push({
            method: propertyKey,
            key: key
        });
    });
}

function createCallback(target: {[str: string]: () => any}, method: string, key: string) {
    return function(event: KeyboardEvent) {
        if (event.ctrlKey && event.key === key) {
            target[method].apply(target);
            event.preventDefault();
        }
    }
}

export let install = function(Vue: any) {
    Vue.mixin({
        created() {
            if (this.$options["__shortcuts__"]) {
                let shortcuts = this.$options["__shortcuts__"];
                let functions = [];

                for (let s of shortcuts) {
                    let f = createCallback(this, s.method, s.key);
                    document.addEventListener('keydown', f);
                    functions.push(f);
                }

                this["__shortcuts__"] = functions;
            }
        },
        beforeDestroy() {
            if (this["__shortcuts__"]) {
                let shortcuts = this["__shortcuts__"];
                for (let s of shortcuts) {
                    document.removeEventListener('keydown', s);
                }
            }

        }
    });
}